import React from 'react'

import { LayoutChangeEvent, TouchableOpacity } from 'react-native'
import { Map, List } from 'immutable'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { StackNavigationProp } from '@react-navigation/stack'
import dayjs from 'dayjs'
import _ from 'lodash'

import { getSelectedStore } from 'x/redux/selectors'
import * as StoreState from 'x/modules/store/StoreState'
import { ISelectedStoreMap, IVerifySlipCreditSummary, IVerifySlipCreditSummaryItem } from 'x/index'

import * as util from 'x/utils/util'
import * as xFmt from 'x/utils/formatter'
import * as api from 'x/utils/api'
// import CONS from 'x/config/constants'
import * as acl from 'x/utils/acl'
import * as NavActions from 'x/utils/navigation'
import p from 'x/config/platform-specific'

import HStack from 'xui/components/HStack'
import VStack from 'xui/components/VStack'

import XCard from 'xui/components/XCard'
import XText from 'xui/components/XText'
import Box from 'xui/components/Box'
// import XSpinner from '../XSpinner'
import VerifySlipIcon from '../VerifySlipIcon'
import XButton from '../XButton'
import XIcon from '../XIcon'

interface IProps {
  /** storeId to fetch */
  storeId: number
  onPress?: () => void | Promise<void>

  navigation: StackNavigationProp<any>

  // redux
  selectedStore: ISelectedStoreMap
  updateSelectedStoreByKey: (key: string, value: any) => void
}

interface IState {
  // verifySlipTotalRemainingCredit: number | string
  // verifySlipRemainingCreditItems: IVerifySlipCreditSummaryItem[]
  // verifySlipUnusableCreditItems: IVerifySlipCreditSummaryItem[]
  verifySlipCreditSummary: IVerifySlipCreditSummary
  isVerifySlipTrialSuccessPressed: boolean

  isInitialized: boolean
  containerWidth: number
}

class VerifySlipBox extends React.Component<IProps, IState> {
  static displayName = 'VerifySlipBox'

  inProcess: boolean

  lastQueued: NodeJS.Timeout | null

  constructor(props) {
    super(props)

    this.state = {
      // verifySlipTotalRemainingCredit: 0,
      // verifySlipRemainingCreditItems: [],
      // verifySlipUnusableCreditItems: [],

      verifySlipCreditSummary: {
        remaining_credits: [],
        unusable_credits: [],
        total_remaining_credit: 0,
      },

      isVerifySlipTrialSuccessPressed: false,

      isInitialized: false,
      containerWidth: 320,
    }

    this.lastQueued = null
  }

  async componentDidMount(): Promise<void> {
    await this._loadCacheData()
    await util.setStatePromise(this, { isInitialized: true })

    // const { selectedStore } = this.props
    // if (selectedStore.get('isCache')) {
    //   await util.delay(300)
    //   this._fetchTotalRemainingCredit()
    // }
    this._fetchTotalRemainingCredit()
  }

  componentDidUpdate(prevProps: IProps) {
    if (prevProps.storeId !== this.props.storeId) {
      // console.log('storeId changed ', this.props.storeId)
      this._fetchTotalRemainingCredit()
    }
  }

  // _initData = async (isForceRefresh?: boolean) => {
  //   if (this.lastQueued) {
  //     clearTimeout(this.lastQueued)
  //   }

  //   this.lastQueued = setTimeout(() => {
  //     this._fetchTotalRemainingCredit(isForceRefresh)
  //   }, 200)
  // }

  _loadCacheData = async () => {
    const { storeId, selectedStore, updateSelectedStoreByKey } = this.props

    let verifySlipCreditSummary
    const verifySlipCreditSummaryMap = selectedStore.get('verify_slip_credit_summary') || null

    if (verifySlipCreditSummaryMap && Map.isMap(verifySlipCreditSummaryMap)) {
      verifySlipCreditSummary = verifySlipCreditSummaryMap.toJS()
    }

    if (!_.isEmpty(verifySlipCreditSummary)) {
      await util.setStatePromise(this, { verifySlipCreditSummary })
    }
  }

  _fetchTotalRemainingCredit = async () => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true

    const { storeId, selectedStore, updateSelectedStoreByKey } = this.props

    try {
      // const newState: Partial<IState> = {  }
      const { verifySlipCreditSummary: vscs } = this.state
      let verifySlipCreditSummary = _.cloneDeep(vscs)

      const res = await api.fetchVerifySlipCreditSummary({
        store_id: storeId,
        show_remaining_credits: !this._isTrialDeadlineExpired(),
        show_unusable_credits: !this._isTrialDeadlineExpired(),
        offset: 0,
        limit: 20,
      })

      // console.log('_fetchTotalRemainingCredit res => ', res)

      // if (verifySlipCreditSummary && !_.isEmpty(verifySlipCreditSummary)) {
      //   updateSelectedStoreByKey('verify_slip_credit_summary', verifySlipCreditSummary)
      // }

      // const res = await fetchVerifySlipCreditSummary({
      //   store_id: selectedStoreId,
      //   show_remaining_credits: !isTrialDeadlineExpired(),
      //   show_unusable_credits: !isTrialDeadlineExpired(),
      //   offset: 0,
      //   limit: 20,
      // })

      // if (verifySlipCreditSummary && !_.isNil(verifySlipCreditSummary.total_remaining_credit)) {
      //   newState.verifySlipTotalRemainingCredit = verifySlipCreditSummary.total_remaining_credit
      // }

      // if (verifySlipCreditSummary && _.isArray(verifySlipCreditSummary.remaining_credits)) {
      //   newState.verifySlipRemainingCreditItems = verifySlipCreditSummary.remaining_credits
      // }

      // if (verifySlipCreditSummary && _.isArray(verifySlipCreditSummary.unusable_credits)) {
      //   newState.verifySlipUnusableCreditItems = verifySlipCreditSummary.unusable_credits
      // }

      if (verifySlipCreditSummary && !_.isEmpty(verifySlipCreditSummary)) {
        verifySlipCreditSummary = { ...verifySlipCreditSummary, ...res }
        // updateSelectedStoreByKey('verify_slip_credit_summary', verifySlipCreditSummary)
        // await util.delay(100)
      }

      // console.log('_fetchTotalRemainingCredit newState => ', verifySlipCreditSummary)
      if (_.isEmpty(verifySlipCreditSummary)) {
        // console.log('_fetchTotalRemainingCredit newState isEmpty!!! ')
        return
      }
      // console.log('_fetchTotalRemainingCredit newState not empty!!!', verifySlipCreditSummary)

      await util.setStatePromise(this, { verifySlipCreditSummary })
      // this.setState({ verifySlipCreditSummary }, () => {
      //   // console.log('_fetchTotalRemainingCredit this.state => ', this.state)
      // })
      // this.setState(newState)
      await util.delay(100)
      updateSelectedStoreByKey('verify_slip_credit_summary', verifySlipCreditSummary)
      // this.setState(newState)
    } catch (err) {
      console.log('fetchTotalRemainingCredit err', err)
    }

    this.inProcess = false
  }

  // _renderBox = (label: string, value: string, valueColor: string) => {
  //   const { containerWidth } = this.state

  //   let fontSize = 'md'

  //   if (containerWidth < 320) {
  //     fontSize = value.length > 8 ? 'xs' : 'sm'
  //   }

  //   return (
  //     <VStack flex={1} alignItems='center' justifyContent='space-between'>
  //       <XText fontSize={fontSize} color={valueColor || 'black'} bold>
  //         {value}
  //       </XText>

  //       <XText fontSize='sm' textAlign='center'>
  //         {label}
  //       </XText>
  //     </VStack>
  //   )
  // }

  // _navToDailySaleChartView = () => {
  //   const { navigation } = this.props

  //   const store_id = util.getNavParam(this.props, 'store_id')

  //   navigation.dispatch(NavActions.navToDailySaleChartView({ store_id }))
  // }

  _onPress = () => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true

    const { onPress } = this.props
    try {
      onPress()
    } catch (error) {
      console.log('_onPress error => ', error)
    }

    this.inProcess = false
  }

  _onLayout = (event: LayoutChangeEvent) => {
    try {
      const { width } = event.nativeEvent.layout
      this.setState({ containerWidth: width })
    } catch (error) {
      //
    }
  }

  _onPressVerifySlipTrialButton = async () => {
    const { storeId, selectedStore, navigation } = this.props
    try {
      const res = await api.fetchVerifySlipCreditTrial({ store_id: storeId })
      console.log('onPressVerifySlipTrialButton res => ', res)
      if (res.id) {
        // setIsVerifySlipTrialSuccess(true)
        await util.setStatePromise(this, { isVerifySlipTrialSuccess: true })

        await this._fetchTotalRemainingCredit(true)
        await p.op.alertPromise(
          'เติม 1,000 เครดิตเรียบร้อยแล้ว',
          '1,000 เครดิตพร้อมใช้งานแล้ว! คุณสามารถเริ่มใช้งานได้เลย หลังจาก "กดเปิดใช้งานฟีเจอร์และบัญชีรับชำระในหน้าตั้งค่า"'
        )
        navigation.dispatch(NavActions.navToStoreSettingVerifySlip({ store_id: storeId, isOnboarding: true }))
      }
    } catch (err) {
      console.log('onPressVerifySlipTrialButton err => ', JSON.stringify(err))
    }
  }

  _isVerifySlipTrialButtonVisible = () => {
    const { isVerifySlipTrialSuccessPressed, verifySlipCreditSummary: vscs } = this.state
    // console.log('Just in isVerifySlipTrialButtonVisible')
    if (isVerifySlipTrialSuccessPressed) {
      // console.log('isVerifySlipTrialSuccessPressed = true')
      return false
    }

    if (this._isTrialDeadlineExpired()) {
      // console.log('isTrialDeadlineExpired = true')
      return false
    }

    let foundVerifySlipCampaignOneAtIndex = vscs.remaining_credits.findIndex((vsrci) => vsrci.verify_slip_campaign_id === 1)
    if (foundVerifySlipCampaignOneAtIndex >= 0) {
      // console.log(`Remaining.foundVerifySlipCampaignOneAtIndex >= 0: ${foundVerifySlipCampaignOneAtIndex}`)
      return false
    }

    foundVerifySlipCampaignOneAtIndex = vscs.unusable_credits.findIndex((vsrci) => vsrci.verify_slip_campaign_id === 1)
    if (foundVerifySlipCampaignOneAtIndex >= 0) {
      // console.log(`Unusable.foundVerifySlipCampaignOneAtIndex >= 0: ${foundVerifySlipCampaignOneAtIndex}`)
      return false
    }
    // console.log('isVerifySlipTrialButtonVisible returns true')
    return true
  }

  _isTrialDeadlineExpired = () => {
    const today = dayjs()
    const deadline = dayjs('2023-11-02 23:59:59')
    if (today.isAfter(deadline)) {
      return true
    }
    return false
  }

  _navToVerifySlipSetting = () => {
    const { storeId, selectedStore, navigation } = this.props
    const s_use_verify_slip = selectedStore.has('s_use_verify_slip') ? selectedStore.get('s_use_verify_slip') : false
    navigation.dispatch(NavActions.navToStoreSettingVerifySlip({ store_id: storeId, isOnboarding: !s_use_verify_slip }))
  }

  _renderVerifySlipBox = () => {
    const { storeId, selectedStore, navigation } = this.props
    const { verifySlipCreditSummary: vscs } = this.state
    const s_use_verify_slip = selectedStore.has('s_use_verify_slip') ? selectedStore.get('s_use_verify_slip') : false
    const s_verify_slip_show_menu = selectedStore.has('s_verify_slip_show_menu') ? selectedStore.get('s_verify_slip_show_menu') : false
    const s_verify_slip_promo_text = selectedStore.has('s_verify_slip_promo_text') ? selectedStore.get('s_verify_slip_promo_text') : null

    let isPromoTextShow = _.isString(s_verify_slip_promo_text)

    if (!this._isTrialDeadlineExpired() && !this._isVerifySlipTrialButtonVisible()) {
      isPromoTextShow = false
    }

    if (!s_verify_slip_show_menu && !s_use_verify_slip) {
      return null
    }

    return (
      <XCard w='full'>
        <HStack w='full' justifyContent='space-between'>
          <Box py='1' pl='3' pr='8'>
            <Box
              position='absolute'
              top={0}
              left={0}
              minH='11'
              minW='166px'
              borderRightWidth='21px'
              borderTopWidth='28px'
              borderRightColor='transparent'
              borderTopColor='primary.500'
            />
            <XText
              // variant='activeDark'
              zIndex={999}
              color='white'
              bold>
              ตรวจสลิปอัตโนมัติ
            </XText>
          </Box>
          <HStack position='absolute' top='0' right='0'>
            <HStack pt='1' pr='2' space='1.5'>
              <VerifySlipIcon success={s_use_verify_slip} inactive={!s_use_verify_slip} />
              <XText variant='inactive' color={s_use_verify_slip ? '#5CB85C' : undefined}>
                {s_use_verify_slip ? 'เปิดใช้งานอยู่' : 'ปิดใช้งานอยู่'}
              </XText>
            </HStack>
          </HStack>
        </HStack>
        {/* {!_.isNil(section.renderPreMenus) ? section.renderPreMenus(sectionIdx) : null} */}

        <VStack w='full'>
          <VStack w='full' px='2' py='1'>
            <HStack w='full' justifyContent='flex-end' space='1'>
              <VStack flex={1} space='0.5'>
                {isPromoTextShow ? (
                  <XText minH='32px' fontSize='md' color='#0046D9' bold>
                    {s_verify_slip_promo_text}
                  </XText>
                ) : null}
                {acl.isSelectedStoreOwner() && isPromoTextShow && this._isVerifySlipTrialButtonVisible() ? (
                  <HStack w='full' pt='0.5' pb='1.5' alignItems='center'>
                    <XButton w='full' h='34px' bg='#0046D9' borderColor='#0046D9' onPress={this._onPressVerifySlipTrialButton}>
                      เริ่มทดลองใช้ ฟรี!
                    </XButton>
                  </HStack>
                ) : null}
              </VStack>

              {acl.isSelectedStoreOwner() && !s_use_verify_slip ? (
                <TouchableOpacity onPress={this._navToVerifySlipSetting}>
                  <HStack
                    w='80px'
                    h='32px'
                    px='1.5'
                    py='0.5'
                    borderWidth='1'
                    borderRadius='lg'
                    borderColor='primary.500'
                    space='1.5'
                    alignItems='center'>
                    <XIcon name='gear' family='FontAwesome' />
                    <XText flex={1} textAlign='center' textAlignVertical='center' variant='primary'>
                      ตั้งค่า
                    </XText>
                  </HStack>
                </TouchableOpacity>
              ) : null}
            </HStack>

            {!s_use_verify_slip ? (
              <VStack w='full' pt='1'>
                <XText variant='inactive'>หมดปัญหาสลิปปลอม สลิปซ้ำ ยอดสลิปไม่ตรง โอนผิดบัญชี ให้ระบบยืนยันสลิปที่ถูกต้องให้อัตโนมัติ</XText>
                {this._isVerifySlipTrialButtonVisible() ? (
                  <XText variant='inactive'>
                    กดปุ่ม{' '}
                    <XText color='#0046D9' bold>
                      "เริ่มทดลองใช้ ฟรี!"
                    </XText>{' '}
                    เพื่อ <XText bold>รับสิทธิ์และตั้งค่าเปิดการใช้งาน</XText>
                    {acl.isSelectedStoreOwner() ? null : <XText variant='inactive'> (เฉพาะบัญชีเจ้าของร้านที่จะเห็นปุ่มและกดได้)</XText>}
                  </XText>
                ) : (
                  <XText variant='inactive'>
                    กดปุ่ม{' '}
                    <XText variant='primary' bold>
                      "ตั้งค่า"
                    </XText>{' '}
                    เพื่อ <XText bold>เปิดการใช้งาน</XText> หรือซ่อนเมนูนี้
                    {acl.isSelectedStoreOwner() ? null : <XText variant='inactive'> (เฉพาะบัญชีเจ้าของร้านที่จะเห็นปุ่มและกดได้)</XText>}
                  </XText>
                )}
              </VStack>
            ) : null}
          </VStack>

          <HStack w='full' px='2' pb='2' space='2'>
            <XButton
              variant='outline'
              borderColor='gray.500'
              w='32%'
              h='54px'
              p='0.5'
              onPress={() => navigation.dispatch(NavActions.navToVerifySlipCreditSummaryView)}>
              <VStack alignItems='center' justifyContent='center'>
                <XText variant='inactive' numberOfLines={1} fontSize='md'>
                  {_.isString(vscs.total_remaining_credit) ? vscs.total_remaining_credit : xFmt.formatDecimal(vscs.total_remaining_credit)}
                </XText>
                <XText w='full' variant='inactive' numberOfLines={1} adjustsFontSizeToFit textAlign='center' textVerticalAlign='center'>
                  เครดิต
                </XText>
              </VStack>
            </XButton>

            <XButton
              variant='outline'
              borderColor='gray.500'
              w='32%'
              h='56px'
              p='0.5'
              onPress={() => navigation.dispatch(NavActions.navToVerifySlipCreditHistoryView({ store_id: storeId }))}>
              <VStack alignItems='center' justifyContent='center'>
                <XIcon inactive name='back-in-time' family='Entypo' />
                <XText w='full' variant='inactive' numberOfLines={1} adjustsFontSizeToFit textAlign='center' textVerticalAlign='center'>
                  ประวัติเครดิต
                </XText>
              </VStack>
            </XButton>

            <Box w='32%' />
          </HStack>
        </VStack>
      </XCard>
    )
  }

  render() {
    const { isInitialized } = this.state

    if (!isInitialized) {
      return null
    }

    return this._renderVerifySlipBox()

    // return (
    //   <XCard>
    //     <VStack w='full' p='2' onLayout={this._onLayout}>
    //       {this._renderVerifySlipBox()}
    //     </VStack>
    //   </XCard>
    // )
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
  }),
  (dispatch) => ({
    updateSelectedStoreByKey: bindActionCreators(StoreState.updateSelectedStoreByKey, dispatch),
    dispatch,
  })
)(VerifySlipBox)
